import { useState } from 'react'
import Projects from '../../api/projects'


const ClickHandler = () => {
  window.scrollTo(10, 0)
}

const ProjectSectionHome = (props) => {
  const [activeCategory, setActiveCategory] = useState('all')

  // Filter projects based on active category
  const filteredProjects =
    activeCategory === 'all'
      ? Projects
      : Projects.filter((project) => project.subTitle === activeCategory)

  return (
    <section className={'' + props.hclass}>
      <div className="container">
        <div className="title">
          <h2 className="fade_bottom">Construction Materials</h2>
        </div>


        <div className="container">
          <div className="service-wrap">
          {Projects.slice(0, 12).map((project, index) => (
            <div className="service-card" key={index}>
              <div className="card-content">
                <img src={project.pimg} alt={project.title} />
                {/* <h2>{service.title}</h2>
                <p>{service.description}</p> */}
              </div>
            </div>
          ))}
        </div>
        
         
        </div>
       
      </div>
    </section>
  )
}
export default ProjectSectionHome
